/**
 * 準備度・期限・体制・機能対応表の文言（ja / en）。i18n.ts が合成する。
 * 制度用語（評価基準の本文・様式名・ロール名・台帳名）は訳さない。
 */
export const ja: Record<string, string> = {
  // 準備度
  "dash.exports": "確定出力の履歴",
  "dash.downloadZip": "ZIP を受け取る",
  "dash.gapNone": "該当する項目はありません。",

  // 期限
  "obl.actions": "操作",
  "obl.completeDo": "完了にする",
  "obl.waiveDo": "免除する",
  "obl.responsesOpen": "部署別回答を開く",
  "obl.completeFor": "「{title}」を完了にする",
  "obl.waiveFor": "「{title}」を免除する",
  "obl.responsesFor": "「{title}」の部署別回答を開く",
  "obl.completed": "完了にしました",
  "obl.waived": "免除しました",
  "obl.empty": "この条件の期限はありません",
  "obl.clearFilter": "絞り込みを外す",
  "obl.waivedBecause": "免除の理由: {reason}",
  "obl.answered": "回答済み",
  "obl.answerSent": "回答を送りました",
  "obl.responsesNone": "まだ部署に回答を依頼していません",
  "obl.completeForDue": "「{title}」（期限 {date}）を完了にする",
  "obl.waiveForDue": "「{title}」（期限 {date}）を免除する",
  "obl.responsesForDue": "「{title}」（期限 {date}）の部署別回答を開く",
  "obl.sum.overdue": "期限超過 {n}件",
  "obl.sum.soon": "7日以内 {n}件",
  "obl.sum.join": "・",
  "obl.sum.end": "。",
  "obl.sum.monthLeft": "今月はあと {n}件です。",
  "obl.sum.next": "次の期限は {date}（{rel}）です。",
  "obl.sum.calm": "急ぎの期限はありません。",
  "obl.sum.nothing": "対応を待っている期限はありません。",
  "obl.tile.overdue": "期限超過",
  "obl.tile.soon": "7日以内",
  "obl.tile.upcoming": "これから",
  "obl.tile.done": "完了",
  "obl.tile.waived": "免除",
  "obl.tileAria": "{label} {n}件",
  "obl.showing": "{label}の {n}件を表示しています",
  "obl.showingAll": "すべての {n}件を表示しています",
  "obl.lg.title": "記号の見方",
  "obl.lg.multi": "同じ月に複数",
  "obl.map.title": "1年の見通し",
  "obl.map.range": "{from}〜{to}",
  "obl.map.prevYear": "前の12か月を見る",
  "obl.map.nextYear": "次の12か月を見る",
  "obl.map.now": "今月に戻る",
  "obl.map.none": "定期の期限はありません。",
  "obl.map.srOf": "この期間の{n}回中 {parts}",
  "obl.map.srNone": "この期間に期限はありません",
  "obl.map.next": "次の期限は {date}",
  "obl.map.nextShort": "次は {date}",
  "obl.mk.overdue": "期限超過 {n}",
  "obl.mk.soon": "7日以内 {n}",
  "obl.mk.upcoming": "これから {n}",
  "obl.mk.done": "完了 {n}",
  "obl.mk.waived": "免除 {n}",
  "obl.ev.title": "出来事に応じて発生する期限",
  "obl.ev.hint": "インシデントの報告や修正プログラムの公開などをきっかけに作られます。",
  "obl.ev.open": "対応中 {n}件",
  "obl.ev.none": "対応中のものはありません（これまで {n}件）",
  "obl.list.title": "期限の一覧",
  "obl.list.filtered": "期限の一覧: {label}",
  "obl.sec.overdue": "期限を過ぎたもの",
  "obl.sec.overdueHint": "済んでいれば「完了にする」で記録してください。該当しない場合は、免除の理由を書いてください。",
  "obl.sec.overdueHintMember": "済んでいれば「完了にする」で記録してください。担当でない場合は、セキュリティ担当部署長に知らせてください。",
  "obl.sec.next30": "今後30日",
  "obl.sec.next30None": "今後30日に期限はありません。",
  "obl.sec.later": "それ以降",
  "obl.sec.closed": "完了・免除",
  "obl.sec.count": "{n}件",
  "obl.detail.instances": "この期限の回（{n}回）",
  "obl.detail.completedAt": "完了の記録: {at}",
  "obl.emptyAll": "期限はまだ作られていません",
  "obl.emptyAllBody": "年次サイクルを始めると、点検・報告の期限がここに並びます。",

  // 体制
  "roles.empty": "体制の情報がありません",
  "roles.st.ok": "決定済み",
  "roles.st.noDeputy": "代理者なし",
  "roles.historyOpen": "履歴を見る",
  "roles.historyFor": "{role} の履歴を見る",
  "roles.assignPrimaryFor": "{role} の主担当を決める",
  "roles.assignDeputyFor": "{role} の代理者を決める",
  "roles.saved": "{role} の割当を保存しました",
  "roles.noHistory": "割当の履歴はまだありません",
};

export const en: Record<string, string> = {
  "dash.exports": "Finalised exports",
  "dash.downloadZip": "Download ZIP",
  "dash.gapNone": "Nothing to show here.",

  "obl.actions": "Actions",
  "obl.completeDo": "Mark as done",
  "obl.waiveDo": "Waive",
  "obl.responsesOpen": "Open department responses",
  "obl.completeFor": "Mark \"{title}\" as done",
  "obl.waiveFor": "Waive \"{title}\"",
  "obl.responsesFor": "Open department responses for \"{title}\"",
  "obl.completed": "Marked as done",
  "obl.waived": "Waived",
  "obl.empty": "No deadlines match this filter",
  "obl.clearFilter": "Clear the filter",
  "obl.waivedBecause": "Waived because: {reason}",
  "obl.answered": "Answered",
  "obl.answerSent": "Response sent",
  "obl.responsesNone": "No department has been asked to respond yet",
  "obl.completeForDue": "Mark \"{title}\" (due {date}) as done",
  "obl.waiveForDue": "Waive \"{title}\" (due {date})",
  "obl.responsesForDue": "Open department responses for \"{title}\" (due {date})",
  "obl.sum.overdue": "{n} overdue",
  "obl.sum.soon": "{n} due within 7 days",
  "obl.sum.join": ", ",
  "obl.sum.end": ".",
  "obl.sum.monthLeft": "{n} left this month.",
  "obl.sum.next": "Next deadline: {date} ({rel}).",
  "obl.sum.calm": "Nothing urgent.",
  "obl.sum.nothing": "No deadlines are waiting on anyone.",
  "obl.tile.overdue": "Overdue",
  "obl.tile.soon": "Due in 7 days",
  "obl.tile.upcoming": "Upcoming",
  "obl.tile.done": "Done",
  "obl.tile.waived": "Waived",
  "obl.tileAria": "{label}: {n}",
  "obl.showing": "Showing {n}: {label}",
  "obl.showingAll": "Showing all {n}",
  "obl.lg.title": "Key",
  "obl.lg.multi": "Several in one month",
  "obl.map.title": "The year at a glance",
  "obl.map.range": "{from} – {to}",
  "obl.map.prevYear": "Show the previous 12 months",
  "obl.map.nextYear": "Show the next 12 months",
  "obl.map.now": "Back to this month",
  "obl.map.none": "No recurring deadlines.",
  "obl.map.srOf": "{n} in this period: {parts}",
  "obl.map.srNone": "Nothing due in this period",
  "obl.map.next": "Next due {date}",
  "obl.map.nextShort": "Next {date}",
  "obl.mk.overdue": "{n} overdue",
  "obl.mk.soon": "{n} due within 7 days",
  "obl.mk.upcoming": "{n} upcoming",
  "obl.mk.done": "{n} done",
  "obl.mk.waived": "{n} waived",
  "obl.ev.title": "Deadlines triggered by events",
  "obl.ev.hint": "Created when something happens, such as an incident report or a patch release.",
  "obl.ev.open": "{n} open",
  "obl.ev.none": "None open ({n} so far)",
  "obl.list.title": "All deadlines",
  "obl.list.filtered": "Deadlines: {label}",
  "obl.sec.overdue": "Past the deadline",
  "obl.sec.overdueHint": "If it’s done, record it with “Mark as done”. If it doesn’t apply, write the reason for waiving it.",
  "obl.sec.overdueHintMember": "If it’s done, record it with “Mark as done”. If it isn’t yours, let the head of the security department know.",
  "obl.sec.next30": "Next 30 days",
  "obl.sec.next30None": "Nothing is due in the next 30 days.",
  "obl.sec.later": "Later",
  "obl.sec.closed": "Done and waived",
  "obl.sec.count": "{n}",
  "obl.detail.instances": "Occurrences ({n})",
  "obl.detail.completedAt": "Recorded as done: {at}",
  "obl.emptyAll": "No deadlines have been created yet",
  "obl.emptyAllBody": "Once the annual cycle starts, inspection and reporting deadlines appear here.",

  "roles.empty": "No role information available",
  "roles.st.ok": "Assigned",
  "roles.st.noDeputy": "No deputy",
  "roles.historyOpen": "View history",
  "roles.historyFor": "View history of {role}",
  "roles.assignPrimaryFor": "Assign the primary for {role}",
  "roles.assignDeputyFor": "Assign the deputy for {role}",
  "roles.saved": "Saved the assignment for {role}",
  "roles.noHistory": "No assignment history yet",
};
